export default {
  failed: 'Aktion fehlgeschlagen',
  success: 'Aktion war erfolgreich',

  // Common
  common: {
    back: 'Zurück',
    continue: 'Weiter',
    next: 'Weiter',
    cancel: 'Abbrechen',
    dismiss: 'Ausblenden',
    retry: 'Erneut versuchen',
    close: 'Schließen',
    required: 'Erforderlich',
    loading: 'Lädt...',
    min: 'Min',
    today: 'Heute',
    noSlots: 'Keine Termine',
    noAppointments: 'Keine Termine',
    noAppointmentsDesc: 'Für dieses Datum sind keine Synchronisationseinträge vorhanden.',
    noResults: 'Keine Ergebnisse gefunden',
    success: 'Erfolgreich gespeichert',
    failed: 'Fehler beim Speichern',
    actions: 'Aktionen',
    show: 'Anzeigen',
    hide: 'Ausblenden',
  },

  // Admin Layout
  admin: {
    title: 'Termin-Verwaltung',
    navigation: 'Navigation',
    permissionsPage: {
      empty: 'Es wurden noch keine Berechtigungen vergeben.',
      removeUser: 'Benutzer entfernen',
      addTitle: 'Berechtigungen für neuen Benutzer anlegen',
      addUser: 'Benutzer hinzufügen',
      loadFailed: 'Berechtigungen konnten nicht geladen werden',
      updated: 'Berechtigungen aktualisiert',
      updateFailed: 'Berechtigungen konnten nicht aktualisiert werden',
      confirmRemove: 'Wirklich alle Berechtigungen von {email} entfernen?',
      alreadyExists: 'Dieser Benutzer ist bereits in der Liste',
    },
    permissionsSubtitle: 'Zusätzliche Rechte für einzelne Benutzer verwalten',
    nav: {
      booking: 'Buchung',
      administration: 'Administration',
      permissions: 'Berechtigungen',
      site: 'Standort',
      darkMode: 'Dunkles Design',
      lightMode: 'Helles Design',
      openMenu: 'Menü öffnen',
      closeMenu: 'Menü schließen',
    },
    calendar: {
      title: 'Kalender',
    },
    invoices: {
      title: 'Rechnungen',
      caption: 'Rechnungsaktionen',
    },
    patients: {
      title: 'Patienten',
    },
    doctolibConfig: {
      title: 'Doctolib-Konfiguration',
      caption: 'Verbindung verwalten',
    },
    apolloConfig: {
      title: 'Apollo-Konfiguration',
      caption: 'Verbindung verwalten',
    },
    integrations: {
      title: 'Integrationen',
      testConnection: 'Verbindung testen',
      testingConnection: 'Verbindung wird getestet...',
      connectionSuccess: 'Verbindung erfolgreich',
      connectionFailed: 'Verbindung fehlgeschlagen',
      refreshAccountInfo: 'Kontoinformationen aktualisieren',
      logout: 'Abmelden',
      loadingStatus: 'Authentifizierungsstatus wird überprüft…',
      connectionDisconnectedTitle: 'Schnittstellen-Verbindung unterbrochen',
      connectionDisconnectedAdminMessage:
        'Für den Zugriff auf diesen Bereich ist eine aktive Verbindung zu den Provider-Schnittstellen (Doctolib und Apollo) erforderlich. Bitte überprüfen Sie die Verbindung unter Integrationen.',
      connectionDisconnectedUserMessage:
        'Für den Zugriff auf diesen Bereich ist eine aktive Verbindung zum Buchungssystem erforderlich. Diese ist derzeit unterbrochen. Bitte wenden Sie sich an einen Administrator, um die Verbindung wiederherzustellen.',
      connectionDisconnectedLexwareAdminMessage:
        'Für den Zugriff auf diesen Bereich ist eine aktive Verbindung zu den Schnittstellen (Lexware und Apollo) erforderlich. Bitte überprüfen Sie die Verbindung unter Integrationen.',
      connectionDisconnectedLexwareUserMessage:
        'Für den Zugriff auf diesen Bereich ist eine aktive Verbindung zum Rechnungssystem erforderlich. Diese ist derzeit unterbrochen. Bitte wenden Sie sich an einen Administrator, um die Verbindung wiederherzustellen.',
      goToIntegrations: 'Zu den Integrationen',
    },
    configEditor: {
      title: 'Konfiguration',
      search: 'Suche in Einstellungen...',
      save: 'Speichern',
      saving: 'Wird gespeichert...',
      saved: 'Konfiguration erfolgreich gespeichert',
      reset: 'Änderungen zurücksetzen',
      error: 'Fehler beim Speichern',
      exportYaml: 'YAML exportieren',
      importYaml: 'YAML importieren',
      importSuccess: 'YAML erfolgreich importiert',
      importError: 'Fehler beim Importieren',
    },
    mappings: {
      title: 'Mappings',
      caption: 'Provider-Zuordnungen verwalten',
      subtitle:
        'Ordnet Kalender, Untersuchungen und Sicherheitsfragen des Buchungswegs dieses Standorts (Doctolib, Formular oder Principa) den Apollo-Optionen zu.',
      subtitleDetail: '{source} → {target}',
      loading: 'Mapping-Daten werden geladen…',
      noTypes: 'Keine Mapping-Typen verfügbar.',
      addRow: 'Mapping hinzufügen',
      removeRow: 'Mapping entfernen',
      save: 'Mappings speichern',
      refreshOptions: 'Optionen aktualisieren',
      removedInvalid: '{count} ungültige Mapping-Einträge entfernt.',
      refreshSuccess: 'Mapping-Optionen aktualisiert',
      refreshFailed: 'Mapping-Optionen konnten nicht aktualisiert werden',
      saveSuccess: 'Mappings gespeichert',
      saveFailed: 'Mappings konnten nicht gespeichert werden',
      duplicateSources: 'Jede Quelle darf nur einmal vorkommen. Duplikate: {list}',
      duplicateTargets: 'Jedes Ziel darf nur einmal vorkommen. Duplikate: {list}',
      duplicateSourcesTargets:
        'Quellen und Ziele müssen eindeutig sein. Quellen: {sources}. Ziele: {targets}.',
      invalidRelation: 'Beziehung verletzt in Zeilen: {rows}',
      unmappedSourcesSummary: '{count} Quelloptionen sind noch nicht gemappt.',
      allSourcesMapped: 'Alle Quelloptionen sind gemappt.',
      showOnlyUnmappedSources: 'Nur ungemappte Quellen anzeigen',
      showUnmappedList: 'Liste anzeigen',
      hideUnmappedList: 'Liste ausblenden',
      unmappedSourcesListTitle: 'Ungemappte Quellen',
      noUnmappedSources: 'Keine ungemappten Quellen verfügbar.',
      relation: {
        one_to_one: 'Beziehung: eins-zu-eins',
        one_to_many: 'Beziehung: eins-zu-viele',
        many_to_one: 'Beziehung: viele-zu-eins',
        many_to_many: 'Beziehung: viele-zu-viele',
      },
    },
    unauthorized: {
      title: 'Keine Berechtigungen',
      message:
        'Dein Account ({email}) hat derzeit keine zugewiesenen Rechte für diesen Bereich. Bitte wende dich an einen Administrator, um Zugriff auf den Kalender, Buchungen oder Rechnungen zu erhalten.',
      restrictedSite:
        'Sie haben keinen Zugriff auf den aktuell ausgewählten Standort "{siteName}". Bitte wählen Sie oben einen anderen Standort aus, für den Ihr Account freigeschaltet ist.',
      permittedSitesTitle: 'Verfügbare Standorte für Ihren Account',
      logout: 'Abmelden',
    },
  },

  // Admin OAuth
  adminAuth: {
    sessionExpired: 'Sitzung abgelaufen',
    sessionRemaining: 'Sitzung läuft noch',
    extendSession: 'Verlängern',
    title: 'Administrator-Zugang',
    subtitle: 'Melden Sie sich mit Ihrem Apollo-Zugang an, um die Verwaltung zu öffnen.',
    login: 'Mit Apollo anmelden',
    logout: 'Abmelden',
    continue: 'Zum Admin-Dashboard',
    authenticated: 'Apollo-Sitzung erkannt',
    signedInAs: 'Angemeldet als',
    unknownUser: 'Unbekannter Benutzer',
    unknownEmail: 'Unbekannte E-Mail',
    roles: 'Rollen',
    noRoles: 'Keine Rollen im Token',
    missingRole: 'Ihrem Konto fehlt die erforderliche Administratorrolle.',
    misconfigured: 'OAuth-Konfiguration fehlt. Bitte Support kontaktieren.',
    menuLabel: 'Administrator-Menü',
    menuButton: 'Admin',
  },

  // Apollo Config
  apollo: {
    title: 'Apollo-Konfiguration',
    subtitle: 'Apollo-Zugangsdaten für Terminbuchung konfigurieren',
    authStatus: 'Authentifizierungsstatus',
    authenticated: 'Authentifiziert',
    notAuthenticated: 'Nicht authentifiziert',
    logout: 'Abmelden',
    loginRequired: 'Anmeldung erforderlich',
    refreshAccountInfo: 'Kontoinformationen aktualisieren',
    accountInfo: 'Kontoinformationen',
    accountInfoRefreshed: 'Kontoinformationen aktualisiert',
    failedToRefresh: 'Aktualisierung der Kontoinformationen fehlgeschlagen',

    credentials: 'Apollo-Zugangsdaten',
    email: 'E-Mail-Adresse',
    emailRequired: 'E-Mail ist erforderlich',
    password: 'Passwort',
    passwordRequired: 'Passwort ist erforderlich',
    authenticate: 'Authentifizieren',

    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
    twoFactorMessage:
      'Ein Verifizierungscode wurde an Ihre E-Mail gesendet. Bitte überprüfen Sie Ihren Posteingang und geben Sie den Code unten ein.',
    enterCode: 'Verifizierungscode eingeben',
    codeRequired: 'Code ist erforderlich',
    verifyCode: 'Code verifizieren',
    resendCode: 'Code erneut senden',
    codeResent: '2FA-Code erneut gesendet - Überprüfen Sie Ihre E-Mail für den neuen Code',
    failedToResend: 'Erneutes Senden des Codes fehlgeschlagen',

    authSuccess: 'Authentifizierung erfolgreich!',
    authFailed: 'Authentifizierung fehlgeschlagen',
    twoFactorSuccess: '2FA-Verifizierung erfolgreich!',
    twoFactorFailed: '2FA-Verifizierung fehlgeschlagen',
    invalidSession: 'Ungültige Sitzung',
    logoutSuccess: 'Abgemeldet und Zugangsdaten gelöscht',
    logoutFailed: 'Abmeldung fehlgeschlagen',

    apolloOptionsRefreshed: 'Apollo-zwischengespeicherte Optionen erfolgreich aktualisiert',

    startCalendarSync: 'Kalender-Sync starten',
    syncStarting: 'Kalender-Sync wird gestartet...',
    syncStartingCaption: 'Dies kann einen Moment dauern',
    syncCompleteSuccess: 'Kalender-Sync abgeschlossen - Keine Inkonsistenzen gefunden',
    syncCompleteSuccessCaption: 'Synchronisiert: {count}',
    syncCompleteDiscrepancies: 'Sync abgeschlossen',
    syncCompleteDiscrepanciesCaption:
      'Konflikte: {conflicts}, Nur Doctolib: {doctolib}, Nur Apollo: {apollo}',
    syncFailed: 'Kalender-Sync fehlgeschlagen',
    viewDetails: 'Details anzeigen',
    syncReportTitle: 'Sync-Bericht',
    syncReportMessage:
      'Gefunden: {count} Inkonsistenzen (Synchronisiert: {synced}, Konflikte: {conflicts}, Nur Doctolib: {doctolib}, Nur Apollo: {apollo}). Details in der Konsole.',
  },

  invoices: {
    title: 'Rechnungen',
    loadReady: 'Abgeschlossene Untersuchungen laden',
    daysBack: 'Tage zurück',
    syncButton: 'Lexware-Entwurf erstellen',
    openLexwareDrafts: 'Lexware Entwürfe öffnen',
    drafts: 'Entwürfe',
    halfDoneTitle: 'Untersuchung {id}: Lexware-Entwurf erstellt, Apollo NICHT aktualisiert',
    halfDoneSendTitle: 'Untersuchung {id}: An LetterXpress gesendet, Apollo NICHT aktualisiert',
    validationTitle: 'Untersuchung {id} kann nicht abgerechnet werden',
    openInLexware: 'In Lexware öffnen',
    openApolloInvoice: 'Rechnung in Apollo öffnen',
    fetchAllHistorical: 'Alle historischen abrufen',
    loadFailed: 'Rechnungsbereite Untersuchungen konnten nicht geladen werden',
    loadFailedStale:
      'Die angezeigte Liste stammt vom letzten erfolgreichen Abruf und ist möglicherweise nicht aktuell.',
    syncSuccess: 'Lexware-Rechnung erstellt',
    syncFailed: 'Lexware-Sync fehlgeschlagen',
    filterPatient: 'Patient',
    filterStatus: 'Status',
    filterStatusAll: 'Alle',
    filterStatusReady: 'Keine Rechnung',
    filterStatusSentOut: 'Übertragen',
    filterStatusProcessed: 'Abgearbeitet',
    filterStatusNeedsChange: 'Zu prüfen',
    stageLabel: 'Stufe',
    stageApollo: 'Apollo',
    stageLexware: 'Lexware',
    stageLetterxpress: 'LetterXpress',
    stageProcessed: 'Abgearbeitet',
    stageNoDispatch: 'Kein Versand',
    markProcessedButton: 'Rechnung abgeschlossen',
    apolloStatusLabel: 'Apollo-Status',
    statusColumnLabel: 'Status',
    unlinkLexwareButton: 'Lexware-Verknüpfung aufheben',
    unlinkNoDispatchButton: 'Kein Versand aufheben',
    confirmUnlinkLexware:
      'Dies hebt nur die Verknüpfung in unserem System auf (die Lexware-ID wird aus Apollo entfernt). In Lexware selbst wird nichts gelöscht - das musst du bei Bedarf dort manuell erledigen. Fortfahren?',
    confirmUnlinkNoDispatch:
      'Dies hebt die Markierung "Kein Versand" auf. Die Rechnung wird wieder in "Übertragen" angezeigt. Fortfahren?',
    unlinkedLexware: 'Lexware-Verknüpfung aufgehoben',
    unlinkedNoDispatch: 'Markierung "Kein Versand" aufgehoben',
    filterDateFrom: 'Datum von',
    filterDateTo: 'Datum bis',
    filterReset: 'Filter zurücksetzen',
    resultsCount: '{count} von {total} angezeigt',
    examinationDate: 'Datum',
    patientLabel: 'Patient',
    amountLabel: 'Betrag',
    lexwareDocument: 'Lexware-Dokument',
    insuranceLabel: 'Versicherung',
    referrerLabel: 'Zuweiser',
    firstExaminerLabel: 'Erstbefunder',
    deviceLabel: 'Gerät',
    paymentOptionLabel: 'Zahlungsoption',
    recipientLabel: 'Rechnungsempfänger',
    missingAddressWarning: 'Keine Adresse in Apollo hinterlegt',
    selectAll: 'Alle auswählen',
    selectRow: 'Untersuchung {id} auswählen',
    selectedSummary: '{count} ausgewählt · {amount}',
    clearSelection: 'Auswahl aufheben',
    bulkRunning: {
      sync: 'Lexware-Entwürfe werden erstellt',
      send: 'Briefe werden an LetterXpress gesendet',
      markProcessed: 'Rechnungen werden abgeschlossen',
    },
    bulkCancel: 'Anhalten',
    bulkCancelling: 'Wird nach der aktuellen Rechnung angehalten …',
    bulkConfirmSend:
      '{count} Rechnungen (zusammen {amount}) per LetterXpress verschicken? Die Briefe werden gedruckt und versendet.',
    bulkConfirmMarkProcessed:
      '{count} Rechnungen (zusammen {amount}) ohne Versand als abgeschlossen markieren?',
    bulkSucceeded: 'Sammelaktion abgeschlossen: {count} erledigt',
    bulkResultTitle: 'Sammelaktion: {succeeded} von {total} erledigt',
    bulkStoppedError:
      'Nach einem Fehler angehalten, damit nichts doppelt angelegt wird. {count} weitere wurden nicht bearbeitet.',
    bulkStoppedCancel: 'Angehalten. {count} weitere wurden nicht bearbeitet.',
  },

  // User Layout
  user: {
    bookingUnavailable: 'Buchung nicht verfügbar',
    bookingUnavailableMessage:
      'Die Buchung ist derzeit nicht möglich. Bitte versuchen Sie es später erneut.',
  },

  // Calendar View
  calendar: {
    searchPlaceholder: 'Patient oder Untersuchung suchen...',
    calendars: 'Kalender',
    month: 'Monat',
    week: 'Woche',
    day: 'Tag',
    today: 'Heute',
    pickDate: 'Datum wählen',
    previous: 'Zurück',
    next: 'Weiter',
    weekdays: {
      sun: 'So',
      mon: 'Mo',
      tue: 'Di',
      wed: 'Mi',
      thu: 'Do',
      fri: 'Fr',
      sat: 'Sa',
    },
    loadingAppointments: 'Termine werden geladen...',
    failedToLoad: 'Termine konnten nicht geladen werden',
    unknown: 'Unbekannt',
    unknownExam: 'Unbekannte Untersuchung',
    more: 'weitere',
    backwardsLimitReached: 'Kalender auf 6 Monate zurück limitiert!',
  },

  // Doctolib Config
  doctolib: {
    title: 'Doctolib-Konfiguration',
    subtitle: 'Doctolib-Zugangsdaten für Terminbuchung konfigurieren',
    authStatus: 'Authentifizierungsstatus',
    authenticated: 'Authentifiziert',
    notAuthenticated: 'Nicht authentifiziert',
    logout: 'Abmelden',
    loginRequired: 'Anmeldung erforderlich',
    refreshAccountInfo: 'Kontoinformationen aktualisieren',
    accountInfo: 'Kontoinformationen',
    accountInfoRefreshed: 'Kontoinformationen aktualisiert',
    failedToRefresh: 'Aktualisierung der Kontoinformationen fehlgeschlagen',

    credentials: 'Doctolib-Zugangsdaten',
    email: 'E-Mail-Adresse',
    emailRequired: 'E-Mail ist erforderlich',
    password: 'Passwort-Hash',
    passwordRequired: 'Passwort ist erforderlich',
    passwordHint: 'Ihr Doctolib-Passwort (wird automatisch gehasht)',
    pin: 'PIN',
    pinHint: '4-stellige PIN, falls für Ihr Konto aktiviert',
    authenticate: 'Authentifizieren',

    pinRequired: 'PIN erforderlich',
    enterPin: '4-stellige PIN eingeben',
    pinMustBe4Digits: 'PIN muss 4 Ziffern haben',
    submitPin: 'PIN absenden',

    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
    twoFactorMessage:
      'Ein Verifizierungscode wurde an Ihre E-Mail gesendet. Bitte überprüfen Sie Ihren Posteingang und geben Sie den Code unten ein.',
    enterCode: 'Verifizierungscode eingeben',
    codeRequired: 'Code ist erforderlich',
    verifyCode: 'Code verifizieren',
    resendCode: 'Code erneut senden',
    codeResent: '2FA-Code erneut gesendet - Überprüfen Sie Ihre E-Mail für den neuen Code',
    failedToResend: 'Erneutes Senden des Codes fehlgeschlagen',

    authSuccess: 'Authentifizierung erfolgreich!',
    authFailed: 'Authentifizierung fehlgeschlagen',
    pinVerificationSuccess: 'PIN-Verifizierung erfolgreich!',
    pinVerificationFailed: 'PIN-Verifizierung fehlgeschlagen',
    twoFactorSuccess: '2FA-Verifizierung erfolgreich!',
    twoFactorFailed: '2FA-Verifizierung fehlgeschlagen',
    invalidSession: 'Ungültige Sitzung',
    logoutSuccess: 'Abgemeldet und Zugangsdaten gelöscht',
    logoutInconsistent: 'Abmeldevorgang abgeschlossen, aber Status könnte inkonsistent sein',
    logoutFailed: 'Abmeldung fehlgeschlagen',
  },

  serviceDesk: {
    title: 'Service Desk',
    location: 'Standort',
    calendar: 'Kalender',
    allCalendars: 'Alle Kalender',
    stepExamination: 'Untersuchung',
    stepAppointment: 'Termin',
    stepPatient: 'Patient',
    insurance: 'Versicherungsart',
    change: 'Ändern',
    chooseInsuranceFirst: 'Zuerst die Versicherungsart wählen',
    chooseExaminationFirst: 'Zuerst eine Untersuchung wählen',
    patientTitle: 'Titel',
    gender: 'Geschlecht',
    firstName: 'Vorname',
    lastName: 'Nachname',
    birthdate: 'Geburtsdatum',
    phone: 'Telefon',
    email: 'E-Mail',
    additionalQuestions: 'Zusätzliche Fragen',
    summary: 'Buchung',
    patient: 'Patient',
    noSlot: 'Kein Termin ausgewählt',
    acquisition: 'Werbekanal',
    emailLanguage: 'Sprache der E-Mails',
    bookingCodeEmail: 'E-Mail für Buchungscode',
    bookingCodeEmailHint:
      'Principa schickt den Buchungscode an Ihre eigene Adresse, nie an den Patienten.',
    booking: 'Wird gebucht...',
    bookingCodeTitle: 'Buchungscode eingeben',
    bookingCodePlaceholder: 'Buchungscode',
    confirm: 'Bestätigen',
  },

  patients: {
    patient: 'Patient',
    openOverview: 'Patientenübersicht öffnen',
    searchPlaceholder: 'Name, Telefonnummer, E-Mail, Geburtsdatum (TT.MM.JJJJ) oder Patienten-ID',
    searchHint: 'Suchbegriff eingeben',
    incomingCall: 'Eingehender Anruf',
    hits: 'Treffer',
    noHits: 'Keine Patienten gefunden',
    refineSearch: 'Möglicherweise gibt es weitere Treffer - Suche verfeinern.',
    searchError: 'Patientensuche fehlgeschlagen',
    loadError: 'Patient konnte nicht geladen werden',
    selectPatient: 'Patient aus der Trefferliste auswählen',
    matchedOn: {
      phone: 'Telefon',
      name: 'Name',
      email: 'E-Mail',
      birth_date: 'Geburtsdatum',
      id: 'Patienten-ID',
    },
    openInApollo: 'In Apollo öffnen',
    newAppointment: 'Neuer Termin',
    phone: 'Telefon',
    mobile: 'Mobil',
    email: 'E-Mail',
    address: 'Adresse',
    remarks: 'Bemerkungen',
    examinations: 'Untersuchungen',
    noExaminations: 'Keine Untersuchungen',
    allOffices: 'Alle Standorte',
    date: 'Datum',
    office: 'Standort',
    examination: 'Untersuchung',
    status: 'Status',
    invoice: 'Rechnung',
    dispatched: 'Brief versendet',
    noDispatch: 'Kein Briefversand',
  },

  principa: {
    title: 'Principa',
    subtitle: 'Terminbuchung (Siegele Software / PlanOrg)',
    authenticated: 'Verbunden',
    notAuthenticated: 'Nicht verbunden',
    statusRefreshed: 'Status aktualisiert',
    refreshInProgress:
      'Aktualisierung läuft - das kann einige Minuten dauern, da alle Untersuchungsarten einzeln bei Principa geprüft werden.',
  },

  lexware: {
    title: 'Lexware',
    subtitle: 'ERP & Buchhaltung',
    authenticated: 'Authentifiziert',
    notAuthenticated: 'Nicht authentifiziert',
    refreshStatus: 'Kontoinformationen aktualisieren',
    statusRefreshed: 'Status aktualisiert',
    failedToRefresh: 'Status konnte nicht aktualisiert werden',
    organization: 'Organisation',
    user: 'Benutzer',
    features: 'Funktionen',
    connectionId: 'Verbindungs-ID',
  },

  lexwareStatus: {
    label: 'Lexware-Status',
    loading: 'Lexware-Status wird geladen',
    unknown: 'unbekannt',
    unknownHint: 'Der Status konnte nicht aus Lexware gelesen werden',
    openOf: 'offen: {open} von {total}',
    paidOn: 'bezahlt am {date}',
    dueOn: 'fällig am {date}',
    status: {
      draft: 'Entwurf',
      open: 'Offen',
      overdue: 'Überfällig',
      paid: 'Bezahlt',
      voided: 'Storniert',
      transferred: 'Überweisung läuft',
      sepadebit: 'Lastschrift',
    },
  },

  letterxpress: {
    title: 'LetterXpress',
    subtitle: 'Postversand',
    authenticated: 'Authentifiziert',
    notAuthenticated: 'Nicht authentifiziert',
    statusRefreshed: 'Status aktualisiert',
    balance: 'Guthaben',
    sendButton: 'An LetterXpress senden',
    sendSuccess: 'An LetterXpress gesendet.',
    unlinkButton: 'LetterXpress-Verknüpfung aufheben',
    confirmUnlink:
      'Dies hebt nur die Verknüpfung in unserem System auf (die LetterXpress-Job-ID wird aus Apollo entfernt). Bei LetterXpress selbst wird nichts gelöscht. Fortfahren?',
    unlinked: 'LetterXpress-Verknüpfung aufgehoben',
    addressMismatchToast:
      'Die von LetterXpress erkannte Adresse weicht von der erwarteten ab - bitte prüfen.',
    addressMismatchTitle: 'Untersuchung {id}: Adresse bei LetterXpress weicht ab',
    addressMismatchExpected: 'Erwartet',
    addressMismatchDetected: 'Von LetterXpress erkannt',
  },

  // Booking Page
  booking: {
    privacyConsentText1:
      'Ich bin damit einverstanden, dass diese Website meine eingereichten Informationen speichert, damit auf meine Anfrage geantwortet werden kann. Die Daten werden gemäß der ',
    privacyConsentLink: 'Datenschutzvereinbarung',
    privacyConsentText2: ' verarbeitet. *',
    insuranceBG: 'Berufsgenossenschaft (BG)',
    insurancePrivate: 'Privat versichert',
    insuranceSelfPayer: 'Selbstzahler',
    noSlotsForSelection: 'Für Ihre Auswahl sind aktuell keine Online-Termine verfügbar.',
    loadDemoData: 'Demo-Daten laden:',
    salutation: 'Anrede',
    emailAddress: 'E-Mail-Adresse',
    streetAndNumber: 'Straße & Hausnummer',
    cityLabel: 'Ort',
    submitting: 'Wird übermittelt...',

    title: 'Termin buchen',
    insurance: 'Versicherung',
    bookDirect: 'Direkt buchen',
    clear: 'Verwerfen',
    openInCalendar: 'Im Kalender öffnen',

    // Step 1: Standort
    step1Title: 'Standort',
    chooseLocation: 'Standort wählen',
    selectLocation: 'Bitte wählen Sie einen Standort aus',

    // Step 2: Versicherung
    step2Title: 'Versicherung',
    chooseInsurance: 'Versicherungsart wählen',
    BG: 'BG',
    Private: 'Privat',
    'Self-payer': 'Selbstzahler',
    insurance_bg: 'BG',
    insurance_private: 'Privat',
    insurance_self_payer: 'Selbstzahler',
    selectInsurance: 'Bitte wählen Sie Ihre Versicherung aus',

    // Step 3: Terminart
    step3Title: 'Terminart',
    chooseCategory: 'Terminart wählen',
    selectCategory: 'Bitte wählen Sie eine Terminart aus',

    // Step 4: Besuchsgrund
    step4Title: 'Besuchsgrund',
    chooseExamination: 'Besuchsgrund wählen',
    searchExaminations: 'Besuchsgründe durchsuchen',
    other: 'Sonstige',
    selectAtLeastOne: 'Bitte wählen Sie einen Besuchsgrund aus',

    // Step 5: Termin
    step5Title: 'Termin',
    selectAppointmentTime: 'Terminzeit auswählen',
    calendarOptional: 'Kalender (Optional)',
    selectTimeSlot: 'Bitte wählen Sie einen Zeitslot aus',
    failedToLoadSlots: 'Zeitslots konnten nicht geladen werden',
    noSlotsAvailable: 'Keine Termine für die aktuelle Auswahl verfügbar.',
    selectedSlot: 'Ausgewählter Termin',
    preferredTimes: 'Wunschtermine',
    selectPreferredTimes: 'Bitte wählen Sie mindestens einen Wunschtermin aus.',
    selectPreferredTimesDesc: 'Bitte wählen Sie die gewünschten Zeiten aus.',
    selected: 'Ausgewählt',
    preferredTime: 'Wunschtermin',
    preferredTimesPlural: 'Wunschtermine',

    // Step 6: Ihre Daten
    step6Title: 'Ihre Daten',
    personalInformation: 'Persönliche Informationen',
    fillDemoData: 'Demo-Daten ausfüllen',
    patientTitle: 'Titel',
    firstName: 'Vorname',
    lastName: 'Nachname',
    gender: 'Geschlecht',
    dateOfBirth: 'Geburtsdatum',
    contact: 'Kontakt',
    email: 'E-Mail',
    invalidEmail: 'Ungültige E-Mail',
    phoneNumber: 'Telefonnummer',
    address: 'Adresse',
    street: 'Straße',
    zipCode: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',
    medicalInformation: 'Medizinische Informationen',
    allergies: 'Allergien',
    cardiacPacemaker: 'Herzschrittmacher',
    claustrophobia: 'Klaustrophobie',
    metalImplant: 'Metallimplantat',
    bedridden: 'Bettlägrig',
    externalRisk: 'Akute Fremdgefährdung',
    kidneyProblem: 'Nierenproblem bekannt',
    neurostimulator: 'Neurostimulator',
    selfHarm: 'Akute Selbstgefährdung',
    accompanied: 'Muss der Patient begleitet werden',
    additionalQuestions: 'Zusätzliche Fragen:',
    requiredFields: '* Pflichtfelder',
    fillRequiredFields: 'Bitte füllen Sie die erforderlichen Felder aus',
    fillRequiredReason: 'Bitte geben Sie einen Besuchsgrund an',
    genderMale: 'Männlich',
    genderFemale: 'Weiblich',
    genderDiverse: 'Divers',
    genderIndeterminate: 'Unbestimmt',
    genderNone: 'Keine Angabe',

    // Step 7: Zusammenfassung
    step7Title: 'Zusammenfassung',
    confirmBooking: 'Buchungsanfrage bestätigen',
    practice: 'Standort',
    category: 'Terminart',
    examination: 'Besuchsgrund',
    dateTime: 'Datum & Uhrzeit',
    patient: 'Patient',
    confirmAndBook: 'Bestätigen & Anfragen',
    bookingYourAppointment: 'Ihre Terminbuchung wird angefragt...',

    dynamicFields: {
      examination_reason: {
        question: 'Grund für den Besuch',
        shortLabel: 'Kurzbeschreibung Ihrer Symptome',
      },
    },
  },

  // Form booking (magazin/network, embedded on the websites)
  bookingForm: {
    heading: 'Termin anfragen',
    lead: 'In wenigen Schritten zu Ihrer Untersuchung. Das dauert etwa 2 Minuten.',
    stepOf: 'Schritt {current} von {total}',
    loadFailed:
      'Die Untersuchungen konnten gerade nicht geladen werden. Bitte versuchen Sie es in einigen Minuten erneut.',
    reload: 'Seite neu laden',
    back: 'Zurück',
    backToStep: 'Zurück zu Schritt {step}: {label}',
    next: 'Weiter',
    toReview: 'Weiter zur Übersicht',
    steps: {
      insurance: 'Versicherung',
      examination: 'Untersuchung',
      time: 'Termin',
      contact: 'Kontaktdaten',
      review: 'Prüfen und senden',
    },
    insuranceTitle: 'Wie sind Sie versichert?',
    insuranceDescBG: 'Nach einem Arbeits- oder Wegeunfall',
    insuranceDescPrivate: 'Private Krankenversicherung oder Beihilfe',
    insuranceDescSelfPayer: 'Sie bezahlen die Untersuchung selbst',
    examinationTitle: 'Welche Untersuchung benötigen Sie?',
    department: 'Fachbereich',
    examination: 'Untersuchung',
    duration: 'ca. {minutes} Min.',
    noExaminations: 'Für diese Auswahl können Sie online leider keine Untersuchung anfragen.',
    timeTitle: 'Wann passt es Ihnen?',
    preferredHint:
      'Wählen Sie alle Zeiten, die Ihnen passen. Wir melden uns dann mit einem festen Termin.',
    selectAll: 'Ich bin flexibel: alle auswählen',
    timesSelected: 'Noch keine Zeit ausgewählt | {n} Zeit ausgewählt | {n} Zeiten ausgewählt',
    selectedSlot: 'Ihr Termin',
    change: 'Ändern',
    contactTitle: 'Wie erreichen wir Sie?',
    person: 'Zu Ihrer Person',
    contact: 'Kontakt',
    address: 'Adresse',
    medical: 'Zur Untersuchung',
    optional: '(optional)',
    salutationPlaceholder: 'z. B. Dr.',
    day: 'Tag',
    month: 'Monat',
    year: 'Jahr',
    dayPlaceholder: 'TT',
    monthPlaceholder: 'MM',
    yearPlaceholder: 'JJJJ',
    zipCode: 'PLZ',
    yes: 'Ja',
    no: 'Nein',
    errorSummary: 'Bitte prüfen Sie noch eine Angabe: | Bitte prüfen Sie noch {n} Angaben:',
    errors: {
      insurance: 'Bitte wählen Sie Ihre Versicherung aus.',
      examination: 'Bitte wählen Sie eine Untersuchung aus.',
      preferredTimes: 'Bitte wählen Sie mindestens eine Zeit aus.',
      slot: 'Bitte wählen Sie einen Termin aus.',
      gender: 'Bitte wählen Sie Ihr Geschlecht aus.',
      firstName: 'Bitte geben Sie Ihren Vornamen ein.',
      lastName: 'Bitte geben Sie Ihren Nachnamen ein.',
      birthdate: 'Bitte geben Sie Ihr Geburtsdatum vollständig ein, z. B. 07 03 1952.',
      phone: 'Bitte geben Sie eine Telefonnummer ein.',
      email: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
      emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein, z. B. name{'@'}beispiel.de.",
      street: 'Bitte geben Sie Straße und Hausnummer ein.',
      zipCode: 'Bitte geben Sie Ihre PLZ ein.',
      city: 'Bitte geben Sie Ihren Ort ein.',
      country: 'Bitte wählen Sie Ihr Land aus.',
      answer: 'Bitte beantworten Sie diese Frage.',
      required: 'Bitte füllen Sie dieses Feld aus.',
      privacy:
        'Bitte stimmen Sie den Datenschutzhinweisen zu, damit wir Ihre Anfrage bearbeiten können.',
    },
    reviewTitle: 'Bitte prüfen Sie Ihre Angaben',
    reviewPerson: 'Ihre Angaben',
    bornOn: 'geb. {date}',
    submit: 'Terminanfrage senden',
    submitNotePreferred:
      'Das ist noch keine feste Buchung. Wir melden uns mit einem Terminvorschlag bei Ihnen.',
    submitNoteVerify:
      'Nach dem Absenden schicken wir Ihnen eine E-Mail. Bitte bestätigen Sie Ihre Anfrage über den Link darin.',
    weekdays: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
    },
  },

  // Verify Booking
  verify: {
    verifying: 'Ihr Termin wird verifiziert...',
    confirmed: 'Bestätigt!',
    appointmentBooked: 'Ihr Termin ist jetzt gebucht.',
    confirmationEmailSent: 'Eine Bestätigungs-E-Mail wurde an Ihre E-Mail-Adresse gesendet.',
    requestReceived: 'Anfrage übermittelt!',
    requestSubmitted: 'Ihre Terminanfrage wurde erfolgreich übermittelt.',
    requestConfirmationEmailSent:
      'Wir prüfen Ihre Anfrage und senden Ihnen in Kürze eine Bestätigung per E-Mail.',
    date: 'Datum',
    time: 'Uhrzeit',
    bookAnother: 'Weiteren Termin anfragen',

    bookingUnavailable: 'Buchung nicht verfügbar',
    verificationFailed: 'Verifizierung fehlgeschlagen',
    invalidOrExpired: 'Ungültiger oder abgelaufener Link',
    alreadyConfirmedMessage:
      'Dies könnte bedeuten, dass der Termin bereits bestätigt wurde oder der Zeitslot nicht mehr verfügbar ist.',
    expiredMessage:
      'Der Verifizierungslink ist möglicherweise abgelaufen (24 Stunden) oder der Termin-Slot ist nicht mehr verfügbar.',
    confirmationEmailNote:
      'Wenn Ihre Buchung erfolgreich war, sollten Sie eine Bestätigungs-E-Mail erhalten haben.',
    startNewBooking: 'Neue Buchung starten',
    bookingCouldNotBeCompleted: 'Buchung konnte nicht abgeschlossen werden',
    noTokenProvided: 'Kein Verifizierungstoken bereitgestellt',
    slotNoLongerAvailable:
      'Verifizierung fehlgeschlagen. Der Slot ist möglicherweise nicht mehr verfügbar.',
  },

  // Request Status
  status: {
    checkYourEmail: 'Überprüfen Sie Ihre E-Mail',
    requestSentSuccess: 'Buchungsanfrage erfolgreich gesendet!',
    verificationLinkSent:
      'Wir haben einen Verifizierungslink an Ihre E-Mail-Adresse gesendet. Bitte klicken Sie auf den Link, um Ihren Termin zu bestätigen.',
    linkExpiresInfoRequest: 'Der Link ist 24 Stunden gültig.',
    linkExpiresInfo:
      'Der Link läuft in 24 Stunden ab. Der Termin-Slot ist für 15 Minuten reserviert.',

    requestFailed: 'Anfrage fehlgeschlagen',
    somethingWentWrong: 'Etwas ist schief gelaufen',
    requestFailedMessage:
      'Wir konnten Ihre Buchungsanfrage zu diesem Zeitpunkt nicht verarbeiten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
    tryAgain: 'Erneut versuchen',
  },

  // Error Pages
  error: {
    notFound: 'Seite nicht gefunden',
    notFoundTitle: 'Seite nicht gefunden',
    notFoundMessage: 'Hoppla. Hier gibt es nichts...',
    goHome: 'Zur Startseite',
    offlineTitle: 'Server nicht erreichbar',
    offlineMessage:
      'Wir können keine Verbindung zu unseren Servern herstellen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    retry: 'Neu laden',
  },

  // Sync
  sync: {
    request: 'Anfrage',
    examination: 'Untersuchung',
    tabLabel: 'Konflikte',
    filterByCalendar: 'Nach Kalender filtern',
    all: 'Alle',
    none: 'Keine',
    noCalendarsFound: 'Keine Kalender gefunden',
    runSyncToSeeCalendars: 'Sync ausführen, um Kalender zu sehen',
    summaryTitle: 'Sync-Zusammenfassung',
    synced: 'Synchron',
    conflicts: 'Konflikte',
    missing: 'Fehlend',
    fieldMismatches: 'Feld-Abweichungen',
    missingInApollo: 'Fehlend in Apollo',
    onlyInApollo: 'Nur in Apollo',
    allInSync: 'Alle Systeme synchron',
    runSyncToSeeResults: 'Sync ausführen, um Ergebnisse zu sehen',
    syncButton: 'Sync',
    startingSync: 'Kalender-Sync wird gestartet...',
    dataTooOld: 'Die Sync-Daten sind älter als 10 Minuten. Bitte aktualisieren.',
    refreshNow: 'Jetzt aktualisieren',
    syncingData: 'Daten werden synchronisiert...',
    pleaseWait: 'Bitte haben Sie einen Moment Geduld',
    syncCompleteDiscrepancies: 'Sync abgeschlossen: {count} Abweichungen gefunden',
    syncCompleteSuccess: 'Kalender-Sync abgeschlossen - Alle Systeme synchron',
    syncFailed: 'Kalender-Sync fehlgeschlagen',
    appointmentMatch: 'Termin-Übereinstimmung',
    appointmentDetails: 'Termindetails',
    notInDoctolib: 'Nicht in Doctolib',
    notInApollo: 'Nicht in Apollo',
    notInApolloDesc:
      'Dieser Termin existiert nur in Doctolib. Bitte wählen Sie einen Werbekanal (Acquisition Channel) aus, um ihn in Apollo anzulegen:',
    sourceAcquisitionChannel: 'Werbekanal (Acquisition Channel)',
    sourceAcquisitionChannelPlaceholder: 'Werbekanal...',
    problemDescription: 'Problembeschreibung:',
    issuesFound: 'Unterschiede:',
    syncDoctolibToApollo: 'Apollo mit Doctolib-Daten aktualisieren',
    createInApollo: 'In Apollo erstellen',
    deleteFromApollo: 'Aus Apollo entfernen',
    actionSuccess: 'Aktion erfolgreich abgeschlossen',
    resolutionFailed: 'Fehlgeschlagen',
    viewInDoctolib: 'In Doctolib ansehen',
    viewInApollo: 'In Apollo ansehen',
    patient: 'Patient',
    date: 'Datum',
    timeslot: 'Zeitslot',
    status: 'Status',
    insurance: 'Versicherung',
    notes: 'Notizen',
    remarks: 'Anmerkungen',
    medicalSafety: 'Medizinische Sicherheit',
    noSafetyChecks: 'Keine Sicherheitsangaben',
    allergies: 'Allergien',
    pacemaker: 'Herzschrittmacher',
    metalImplant: 'Metallimplantat',
    claustrophobia: 'Klaustrophobie',
    examinationType: 'Untersuchungsart',
    calendar: 'Kalender',
    device: 'Gerät',
    office: 'Standort',
    duration: 'Dauer',
    examinationReason: 'Untersuchungsgrund',
    appointmentId: 'Termin-ID',
    reason: 'Grund',
    unknownPatient: 'Unbekannter Patient',
    apolloExamination: 'Apollo Examinations',
    apolloRequest: 'Apollo Requests',
    noAssignedCalendar: 'Kein Kalender zugewiesen',
    unknownAppointment: 'Termin',
    notProvided: 'Keine Angabe',
    fixableViaSync: 'Über Sync korrigierbar',
    manualActionRequired: 'Manuelle Korrektur nötig',
    manualActionRequiredLong: 'Diese Unterschiede müssen manuell in Apollo korrigiert werden.',
    updateExaminationNotSupported:
      'Updates von Untersuchungen sind nur bei Request-Appointments über die UI möglich. Bitte direkt in Apollo anpassen.',
    partialFixHint: '* Nur Patientendaten, Zeiten und Notizen werden automatisch aktualisiert.',
    editInApollo: 'In Apollo bearbeiten',
    daySchedule: 'Tagesplan',
    discrepancies: 'Abweichungen',
    doctolib_only: 'Nur in Doctolib',
    apollo_only: 'Nur in Apollo',
    conflict: 'Konflikt',
    issue: 'Hinweis',
    issues: 'Hinweise',
    patient_name: 'Patientenname',
    patient_email: 'E-Mail',
    patient_birth_date: 'Geburtsdatum',
    patient_phone: 'Telefon',
    patient_gender: 'Geschlecht',
    patient_insurance_type: 'Versicherung',
    patient_street: 'Straße',
    patient_zip_code: 'PLZ',
    patient_city: 'Ort',
    start_datetime: 'Terminzeit',
    examination_name: 'Untersuchung',
    examination_reason: 'Grund',
    site_key: 'Standort',
    device_name: 'Gerät',
    external_provider_id: 'Provider-ID',
    bookingDirectSuccess: 'Termin gebucht: {exam} - {patient} ({date}, {time} Uhr)',
  },

  // Predikto
  predikto: {
    title: 'Buchen Sie Ihren Termin',
    bookNow: 'Jetzt buchen',
    select: 'Auswählen',
    selected: 'Ausgewählt',
    included: 'Inklusive',
    alreadyAdded: 'Bereits hinzugefügt',
    addToCart: 'Hinzufügen',
    duration: 'Dauer',
    steps: {
      examinations: 'Untersuchungen',
      location: 'Standort',
      appointment: 'Termin',
      personalData: 'Ihre Daten',
      summary: 'Zusammenfassung',
    },
    validation: {
      selectGroup: 'Bitte wählen Sie ein Paket, um fortzufahren',
      invalidSelection: 'Bitte stellen Sie sicher, dass Ihre Auswahl gültig ist',
      selectLocation: 'Bitte wählen Sie einen Standort',
      selectSlot: 'Bitte wählen Sie eine Terminzeit',
      fillRequired: 'Bitte füllen Sie alle erforderlichen Felder aus',
    },
    sidebar: {
      title: 'Ihre Buchung',
      examinations: 'Untersuchungen',
      location: 'Standort',
      appointment: 'Termin',
      patient: 'Patient',
      minutes: 'min',
      edit: 'Bearbeiten',
    },
    selection: {
      heading: 'Wählen Sie Ihren Predikto-Scan',
      subtitle:
        'Ganzkörper-MRT zur umfassenden Vorsorge oder spezialisierte MRT-Untersuchungen für die gezielte Vorsorge bestimmter Organe – wählbar einzeln oder in Kombination, stets inklusive Blutanalyse.',
      info: 'Ganzkörper-MRT zur umfassenden Vorsorge oder spezialisierte MRT-Untersuchungen für die gezielte Vorsorge bestimmter Organe – wählbar einzeln oder in Kombination, stets inklusive Blutanalyse.',
      gender: 'Ihr biologisches Geschlecht',
      male: 'Männlich',
      female: 'Weiblich',
    },
    from: 'ab',
    mostPopular: 'Am beliebtesten',
    groups: {
      fullBody: {
        name: 'Ganz&shy;körper',
        description:
          'Früherkennung von 500+ Erkrankungen, darunter Krebs, neurologische Erkrankungen, Aneurysmen sowie Veränderungen der Wirbelsäule.',
        body1: 'Classic Version mit:',
        body2: 'Pro Version zusätzlich mit:',
        price: '1.250 €',
        scanTime: 'ca. 60 Min.',
      },
      bodyCompositionScan: {
        name: 'Body Com&shy;po&shy;si&shy;tion',
        description: 'Der Goldstandard zur präzisen Messung Ihrer Körperzusammensetzung.',
        price: '249 €',
        scanTime: 'ca. 15 Min.',
      },
      fullBodyClassic: {
        name: 'Ganz&shy;körper Classic',
        description:
          'Die solide Basis für Ihre Gesundheitsvorsorge – inkl. Ganzkörper-MRT und Blutanalyse.',
      },
      fullBodyPro: {
        name: 'Ganz&shy;körper Pro',
        description:
          'Unsere umfassendste Vorsorge – zusätzlich mit Herz-MRT, Prostata-MRT (bei Männern) und Body-Composition-Scan.',
      },
      individual: {
        name: 'In&shy;di&shy;vi&shy;du&shy;ell',
        description: 'Stellen Sie Ihren Scan individuell nach Ihren Bedürfnissen zusammen.',
        body1: 'Einzeln oder zusammen buchbar:',
        body2: 'Immer inkludiert',
        price: '549 €',
        scanTime: 'ca. 30 Min.',
      },
    },
    products: {
      wholeBodyMRI: {
        name: 'Ganz&shy;körper-MRT',
        description: 'Detaillierter Scan Ihres gesamten Körpers',
        subtitleFullBody:
          'für hochauflösende Bilder von Gehirn, Kopf, Hals, Wirbelsäule, Bauch, Becken, Beine',
        subtitleIndividual:
          'für hochauflösende Bilder von Gehirn, Kopf, Hals, Wirbelsäule, Bauch, Becken, Beine',
      },
      brainMRI: {
        name: 'Kopf-MRT',
        description: 'Detaillierter Scan Ihres Gehirns und der Blutgefäße',
        subtitleIndividual:
          'für hochauflösende Bilder von Gehirn (bei Auswahl von Ganzkörper-MRT bereits inkludiert)',
      },
      heartMRI: {
        name: 'Herz-MRT',
        description: 'Beurteilung der Herzfunktion und -struktur',
        subtitleFullBody:
          'für hochauflösende Bilder des Herzens trotz Herzschlag (im Ganzkörper-MRT nicht ausreichend präzise)',
        subtitleIndividual:
          'für hochauflösende Bilder des Herzens trotz Herzschlag (im Ganzkörper-MRT nicht ausreichend präzise)',
      },
      prostateMRI: {
        name: 'Prostata-MRT',
        description: 'Spezialisierte Vorsorgeuntersuchung für die Prostata',
        subtitleFullBody:
          'für hochauflösende Bilder der Prostata (im Ganzkörper-MRT nicht ausreichend präzise)',
        subtitleIndividual:
          'für hochauflösende Bilder der Prostata (im Ganzkörper-MRT nicht ausreichend präzise)',
      },
      bodyCompositionScan: {
        name: 'Körperzusammensetzungs-Scan',
        description: 'Analyse der Fett- und Muskelverteilung',
        subtitleFullBody:
          'Goldstandard zur Analyse von Muskelvolumen, -qualität und Fettverteilung (Bauch, Leber, Unterhaut)',
        subtitleIndividual:
          'Goldstandard zur Analyse von Muskelvolumen, -qualität und Fettverteilung (Bauch, Leber, Unterhaut)',
        subtitleStandalone1:
          'Messung von Muskelvolumen und -qualität sowie Fettvolumen- und Fettverteilung (Bauch, Leber, Unterhaut)',
        subtitleStandalone2:
          'Besonders für Personen, die ihren Körper aktiv verbessern oder Veränderungen durch Ernährung, Medikamente oder Training objektiv nachvollziehen möchten.',
        subtitleStandalone3: 'Gut zu wissen:',
        subtitleStandalone4:
          'der Body-Composition-MRT kann auch im Rahmen unseres umfassenden “Ganzkörper-Scan Pro” oder “Individueller Scan” durchgeführt werden.',
      },
      bloodAnalysis: {
        name: 'Blutanalyse',
        description: 'Umfassender Bluttest für wichtige Gesundheitsmarker',
        subtitleIndividual:
          'ergänzt das MRT ideal – deckt frühzeitig Veränderungen auf, die im MRT (noch) nicht sichtbar sind',
      },
    },
    addOns: {
      heading: 'Untersuchungen',
      subtitle: 'Passen Sie Ihren Scan individuell an Ihre Gesundheitsprioritäten an.',
      classic: {
        name: 'Ganz&shy;körper Classic',
        heading: 'Classic Version mit:',
      },
      pro: {
        name: 'Ganz&shy;körper Pro',
        heading: 'Pro Version zusätzlich mit:',
      },
      invalidCombination: 'Diese Kombination ist leider nicht möglich.',
    },
    location: {
      heading: 'Wohin möchten Sie gehen?',
      subtitle: 'Wählen Sie einen unserer Premium-Partnerstandorte.',
      searchPlaceholder: 'Standorte suchen...',
      viewOnMap: 'Auf Google Maps anzeigen',
    },
    appointment: {
      heading: 'Wann möchten Sie kommen?',
      subtitle: 'Wählen Sie ein passendes Datum und eine Uhrzeit für Ihren Termin.',
      yourAppointment: 'Ihr Termin:',
      selectedDate: 'Ausgewähltes Datum',
      noSlotSelected: 'Bitte wählen Sie ein Zeitfenster aus',
    },
    personalData: {
      heading: 'Ihre Daten',
      subtitle: 'Wir benötigen einige Informationen, um Ihre Buchung zu bearbeiten.',
      infoTitle: 'Ihre Gesundheit ist unsere Priorität',
      infoSubtitle:
        'Ihre Daten werden sicher gespeichert und nur mit dem medizinischen Personal geteilt.',
    },
    summary: {
      heading: 'Überprüfen Sie Ihre Buchung',
      subtitle: 'Bitte überprüfen Sie Ihre Daten, bevor Sie den Termin bestätigen.',
      nextStepsTitle: 'Was passiert als Nächstes?',
      total: 'Gesamt',
      step1: 'Sie erhalten eine Bestätigungs-E-Mail mit allen Details.',
      step2: 'Füllen Sie vor Ihrem Termin den digitalen medizinischen Fragebogen aus.',
      step3: 'Erscheinen Sie 15 Minuten vor Ihrem Termin.',
      nextStep1Title: 'Termin bestätigen',
      nextStep1Desc: 'Überprüfen Sie Ihre Auswahl und schließen Sie die Buchung ab.',
      nextStep2Title: 'Vor Ort bezahlen',
      nextStep2Desc: 'Die Zahlung erfolgt bequem am Tag Ihrer Untersuchung in der Praxis.',
    },
  },
};
